import { useCallback, useState } from "react";

const STORAGE_KEY = "sidebarOpenSubMenus";

/**
 * Manages sidebar submenu state: which submenus are expanded (show-all toggle)
 * and which are open, persisting the open state to localStorage.
 *
 * @returns {{
 *   expandedSubMenus: Object,
 *   toggleShowAll: (key: string) => void,
 *   isSubMenuOpen: (key: string) => boolean,
 *   toggleSubMenu: (key: string) => void,
 * }}
 */
export function useSidebarSubMenus() {
  const [expandedSubMenus, setExpandedSubMenus] = useState({});
  const [openSubMenus, setOpenSubMenus] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : {};
    } catch {
      return {};
    }
  });

  const toggleShowAll = useCallback(
    (key) => setExpandedSubMenus((prev) => ({ ...prev, [key]: !prev[key] })),
    []
  );

  const isSubMenuOpen = useCallback(
    (key) => (openSubMenus[key] !== undefined ? openSubMenus[key] : true),
    [openSubMenus]
  );

  const toggleSubMenu = useCallback(
    (key) =>
      setOpenSubMenus((prev) => {
        const current = prev[key] !== undefined ? prev[key] : true;
        const next = { ...prev, [key]: !current };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
        return next;
      }),
    []
  );

  return { expandedSubMenus, toggleShowAll, isSubMenuOpen, toggleSubMenu };
}
